{
	"title": "Признание за софтуер с отворен код",
	"backTitle": "Назад"
}
